<template>
  <div class="container">
    <el-menu class="menu"
      mode="horizontal"
      text-color="#2d2f3c"
      active-text-color="#ff3159"
      :default-active="active">
      <img class="logo"
        src="../../assets/image/logo.png"
        alt=""
        @click="go('/','0')">
      <el-menu-item index="1"
        @click="go('about','1')">關於我們</el-menu-item>
      <el-menu-item index="2"
        @click="go('#service','2')">全面服務</el-menu-item>
      <el-submenu index="3">
        <template slot="title">商務合作</template>
        <el-menu-item index="3-1"
          @click="go('brand-marketing','3-1')">品牌營銷</el-menu-item>
        <el-menu-item index="3-2"
          @click="go('marketing','3-2')">市場推廣&合作</el-menu-item>
      </el-submenu>
      <el-menu-item index="4"
        @click="go('concat','4')">聯繫我們</el-menu-item>
    </el-menu>
  </div>
</template>
<script>
import { Menu, MenuItem, Submenu } from "element-ui"
import { throttle } from "@/utils/util"
import { setTimeout } from "timers"
export default {
  components: {
    [Menu.name]: Menu,
    [Submenu.name]: Submenu,
    [MenuItem.name]: MenuItem
  },
  data() {
    return {
      active: "0"
    }
  },
  methods: {
    go(name, index) {
      const _name = this.$route.name
      if (name === _name) return
      if (name === "#service") {
        this.$router.push("/")
        setTimeout(() => {
          window.scrollTo(0, 548)
        })
      } else {
        if (name === "/") window.scrollTo(0, 0)
        this.$router.push(name)
      }
      this.active = index
    }
  },
  created() {
    const name = this.$route.name
    if (name === "home") {
      this.active = "0"
    } else if (name === "about") {
      this.active = "1"
    } else if (name === "brand-marketing") {
      this.active = "3-1"
    } else if (name === "marketing") {
      this.active = "3-2"
    }
  },
  mounted() {
    window.addEventListener(
      "scroll",
      throttle(
        () => {
          const name = this.$route.name
          if (name !== "home") return
          const scrollTop =
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop
          const serviceOffsetTop = document.querySelector(".service").offsetTop
          if (scrollTop + 144 >= serviceOffsetTop) {
            this.active = "2"
          } else {
            this.active = "0"
          }
        },
        200,
        200
      )
    )
  }
}
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  width: 100%;
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
}
.menu {
  width: 950px;
  padding: 25px 0;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-around;
  > img {
    cursor: pointer;
    outline: none;
  }
}
/deep/ .el-menu-item {
  font-size: 22px;
}
/deep/ .el-submenu__title {
  font-size: 22px;
}
/deep/ .el-submenu__icon-arrow {
  font-size: 18px;
}
/deep/ .el-menu.el-menu--horizontal {
  border-width: 0;
}
</style>